import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User added a name to a person',
  name: 'added_name_to_person',
  params: [
    {
      description: 'Person ID',
      name: 'person_id',
      required: true,
      type: 'string',
    },
    {
      description: 'New name',
      name: 'new_name',
      required: true,
      type: 'string',
    },
    {
      description: 'Location of event',
      name: 'location',
      required: true,
      type: 'enum',
      values: [
        'image-preview',
        'people-tab',
        'unnamed-people-page',
        'people-settings',
        'person-page-header',
        'person-page-menu',
      ],
    },
  ],
};

export default META;
